exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/* purgecss start ignore */\n.loading-wrapper {\n  text-align: center;\n  padding: 20px 0;\n}\n\n/* purgecss end ignore */\n", ""]);
